import React from "react"
import styled from "styled-components"

import { AssetFile } from "../../types/contentfulTypes"
import calculatePosition from "../../utils/functions/calculationPosition"
import Helpers from "../../utils/Helpers"
import * as TextStyles from "../styles/TextStyles"

interface Props {
  images: AssetFile[]
}

interface StyledProps {
  leftPosition: string
  topPosition: string
}

interface Bundle {
  [angle: string]: AssetFile[]
}

const CollectionCarousel = (props: Props) => {
  const { images } = props

  const sortedImages = Helpers.sortArrayByProperty(images, "description")
  const groupedBundle: Bundle = Helpers.groupArrayByProperty(sortedImages, "description")

  return (
    <Wrapper>
      {Object.entries(groupedBundle).map(([key, value], index) => (
        <Card key={`${value[0].title + index}`}>
          <Title>{key}</Title>
          <ImagesContainer>
            {value.reverse().map((image, index) => {
              const { left, top } = calculatePosition(image, value.length, index)

              return (
                <Image
                  key={index}
                  src={image?.file?.url}
                  alt={image?.title}
                  leftPosition={left}
                  topPosition={top}
                />
              )
            })}
          </ImagesContainer>
        </Card>
      ))}
    </Wrapper>
  )
}

export default CollectionCarousel

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(335px, 1fr));
  gap: 20px;
  justify-content: stretch;
  padding: 0 20px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  }
`

const Title = styled(TextStyles.H4)`
  position: absolute;
  left: 20px;
  top: 20px;
  font-weight: 600;
  font-size: 24px;
  line-height: 33px;
  color: #000000;
`

const Card = styled.div`
  width: 100%;
  height: 400px;
  background: #ffffff;
  border-radius: 20px;
  position: relative;
  display: grid;
  justify-content: center;
  justify-items: center;
  align-items: center;
  overflow: hidden;
  margin: 0 auto;

  &,
  * {
    transition: 0.8s cubic-bezier(0.075, 0.82, 0.165, 1);
  }

  :hover {
    transform: scale(1.05);
  }
`

const ImagesContainer = styled.div`
  width: 240px;
  height: 100%;
  margin: 0 auto;
  position: relative;
`

const Image = styled.img<StyledProps>`
  max-width: 250px;
  max-height: 250px;
  position: absolute;
  top: ${props => props.topPosition};
  left: ${props => props.leftPosition};
`
